import { useSyncExternalStore } from "react";
import { useLocation } from "react-router-dom";

const subscribe = () => () => {};
const getServerSnapshot = () => "";

// Static HTML is built without query parameters. Match that HTML during the
// first hydration render, then apply the visitor's campaign/booking parameters.
export const useHydratedSearch = () => {
  const { search } = useLocation();
  return useSyncExternalStore(subscribe, () => search, getServerSnapshot);
};
